import React from 'react';
import TertiaryCustomButton from "../../../../../commons/tertiary-custom-button/tertiary-custom-button"
export default function DivisionItem({
  item,
  divisions,
  onNext,
  onDivisionClick,
}) {
  // build children array for stack navigation
  const children = divisions.map((division) => ({
    type: 'division-grid',
    title: division.title,
    division, // pass full object for rendering
  }));

  return (
    <li className="division-item">
      {/* <button
        className="menu-item has-children"
        onClick={() => {
          onNext(children);
          onDivisionClick(divisions);
        }}>
        {item.title} →
      </button> */}
      <TertiaryCustomButton
        classes="customize-tertiary-cls"
        title={item.title}
        onClick={() => {
          onNext(children);
          onDivisionClick(divisions);
        }}
      />
    </li>
  );
}
